<template>
    <v-select
        :options="accountList"
        label="name"
        placeholder="All Accounts"
        @search="onAccountSearch"
        @input="accountSelected"
    >
        <template slot="no-options">
            Search Accounts
        </template>
        <template #open-indicator="{ attributes }">
            <span v-bind="attributes"><chevron-down-icon :size="24" /></span>
        </template>
    </v-select>
</template>

<script>
import {debounce} from "lodash";
import axios from "axios";
import { ChevronDownIcon } from '../../icons';

export default {
    name: "acclaro-account-selector.vue",
    data() {
        return {
            accountList: []
        }
    },
    components: {ChevronDownIcon},
    methods: {
        onAccountSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchAccounts(loading, search, this);
            }
        },
        accountSelected(value) {
            this.$emit('handleSelection', value);
        },
        searchAccounts: debounce((loading, search, vm) => {
            axios.get(`/accounts/all?search=${escape(search)}`).then((res) => {
                vm.accountList = res.data;
                loading(false);
            });
        }, 500),
    },
};
</script>

<style scoped>

.search-input {
    width: 250px;
}
</style>
